<template>
  <div>
    <div class="w-4/5 mb-10 mt-2">
      <zt-alert color="info" :closeIcon="false" filled>
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.customEmails.alertInformation') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
    <zt-input-file
      @change="selectFile"
      outlined
      :label="$t('message.publishDocuments.onlySign.label')"
      append-outer-icon="paperclip-2"
      filetypes=".png, .jpg"
      data-vs-input-file="select_img_file"
      :redIfError="error">
      <template slot="message">
        <span class="text-zt-success text-zt-base" v-if="!error" v-html="$sanitize(successMessage)"></span>
        <span v-else class="text-zt-danger text-zt-base">{{ error }}</span>
      </template>
    </zt-input-file>
  </div>
</template>

<script>
  export default {
    name: 'uploadImage',
    props: {
      selectFile: Function,
      successMessage: String,
      error: String,
    },
  };
</script>
